import React from 'react';
import { observer } from 'mobx-react';
import { numberWithCommas, uppercaseWord } from '../helpers/format';
import UIStore from '../store/store';

@observer
class Sidebar extends React.Component {
    onHeartClick() {
        const { selectedCity } = this.props;
        UIStore.updateLikedPoints(selectedCity);
    }

    getContent() {
        const { selectedCity } = this.props;
        if (!selectedCity) {
            return null;
        }

        const { name, population, description } = selectedCity;

        // TODO: add more characteristics (vibe of city, busyness of city, location type, etc...)

        const isFavorited = UIStore.isFavorited(selectedCity);
        const className = isFavorited ? 'fa-heart' : 'fa-heart-o';

        return (
            <>
                <div style={styles.header}>
                    {name}
                </div>
                <div style={styles.heart}>
                    <i 
                        className={`fa ${className} fa-2x`} 
                        onClick={() => this.onHeartClick()}
                    />
                </div>
                <div style={styles.population}>
                    {population && 'Population: ' + numberWithCommas(population)}
                </div>
                <div style={styles.content}>
                    {description}
                </div>
            </>
        )
    }

    render() {
        const { selectedCity, showSidebar, mapClick } = this.props;

        const className = showSidebar ? 'slideIn' : 'slideOut';

        return (
            <div style={styles.sidebar} id='sideBar' className={className}>
                <div style={styles.type}>
                    {uppercaseWord(UIStore.getType())}
                </div>
                
                {this.getContent()}

                <div style={styles.close} onClick={mapClick}>
                    {'<<'}
                </div>
            </div>
        )
    }
}

const styles = {
    header: {
        textAlign: 'center',
        fontSize: 32,
        fontWeight: 'bold',
        paddingTop: 10
    },
    population: {
        textAlign: 'center',
        padding: 10
    },
    content: {
        padding: 10
    },
    close: {
        position: 'absolute',
        top: 0,
        right: 15,
        cursor: 'pointer'
    },
    type: {
        backgroundColor: 'green',
        color: 'white',
        display: 'inline-block',
        borderRadius: 20,
        padding: '5px 10px',
        fontSize: 14
    },
    heart: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: 10
    }
}
  

export default Sidebar
